(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-item"] && !Shopify.designMode) return;
  try {
    (function() {
    function initCartItemRemove() {
      document.querySelectorAll('[data-cart-remove]').forEach(function(button) {
        if (button.dataset.initialized) return;
        button.dataset.initialized = 'true';

        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const itemKey = button.dataset.cartRemove;
          if (!itemKey) return;

          if (window.liquidAjaxCart && typeof window.liquidAjaxCart.change === 'function') {
            window.liquidAjaxCart.change({ id: itemKey, quantity: 0 });
          } else {
            window.location.reload();
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartItemRemove);
    } else {
      initCartItemRemove();
    }

    document.addEventListener('liquid-ajax-cart:request-end', initCartItemRemove);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-header-quantity"] && !Shopify.designMode) return;
  try {
    // Quantity selector functionality
  document.querySelectorAll('[data-quantity-selector]').forEach((selector) => {
    const input = selector.querySelector('[data-quantity-input]');
    const minusBtn = selector.querySelector('[data-quantity-minus]');
    const plusBtn = selector.querySelector('[data-quantity-plus]');

    if (!input) return;

    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || 99;

    const updateButtons = () => {
      const value = parseInt(input.value) || 1;
      if (minusBtn) minusBtn.disabled = value <= min;
      if (plusBtn) plusBtn.disabled = value >= max;
    };

    if (minusBtn) {
      minusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > min) {
          input.value = currentValue - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          updateButtons();
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue < max) {
          input.value = currentValue + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          updateButtons();
        }
      });
    }

    input.addEventListener('change', () => {
      let value = parseInt(input.value) || min;
      value = Math.max(min, Math.min(max, value));
      input.value = value;
      updateButtons();
    });

    input.addEventListener('blur', () => {
      if (!input.value || parseInt(input.value) < min) {
        input.value = min;
        updateButtons();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-header-share"] && !Shopify.designMode) return;
  try {
    // Copy link functionality
  document.querySelectorAll('[data-copy-link]').forEach((button) => {
    button.addEventListener('click', async () => {
      const url = button.dataset.url;
      const iconLink = button.querySelector('[data-icon-link]');
      const iconCheck = button.querySelector('[data-icon-check]');

      try {
        await navigator.clipboard.writeText(url);

        // Show success state
        if (iconLink) iconLink.classList.add('hidden');
        if (iconCheck) iconCheck.classList.remove('hidden');

        // Reset after 2 seconds
        setTimeout(() => {
          if (iconLink) iconLink.classList.remove('hidden');
          if (iconCheck) iconCheck.classList.add('hidden');
        }, 2000);
      } catch (err) {
        console.error('Failed to copy link:', err);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    (function() {
    // Debounce utility to prevent too many rapid form submissions
    function debounce(func, wait) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    function initQuantityInputs() {
      document.querySelectorAll('.quantity-input').forEach(function(container) {
        if (container.dataset.initialized) return;
        container.dataset.initialized = 'true';

        const input = container.querySelector('[data-quantity-input]');
        const minusBtn = container.querySelector('[data-quantity-minus]');
        const plusBtn = container.querySelector('[data-quantity-plus]');

        if (!input || !minusBtn || !plusBtn) return;

        const min = parseInt(input.min) || 1;
        const max = parseInt(input.max) || 99;

        function updateButtons() {
          const value = parseInt(input.value) || min;
          minusBtn.disabled = value <= min;
          plusBtn.disabled = value >= max;
        }

        // Find the parent form with data-ajax-cart-request-form
        function getParentForm() {
          return input.closest('[data-ajax-cart-request-form]');
        }

        function submitForm() {
          const form = getParentForm();
          if (!form) return;
          const idInput = form.querySelector('input[name="id"]');
          const id = idInput ? idInput.value : null;
          const quantity = parseInt(input.value, 10) || min;
          if (window.liquidAjaxCart && typeof window.liquidAjaxCart.change === 'function' && id) {
            window.liquidAjaxCart.change({ id, quantity });
          }
        }

        // Debounced version for input changes (user typing)
        const debouncedSubmit = debounce(submitForm, 500);

        minusBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const currentValue = parseInt(input.value) || min;
          if (currentValue > min) {
            input.value = currentValue - 1;
            updateButtons();
            submitForm();
          }
        });

        plusBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const currentValue = parseInt(input.value) || min;
          if (currentValue < max) {
            input.value = currentValue + 1;
            updateButtons();
            submitForm();
          }
        });

        // Handle direct input changes (typing)
        input.addEventListener('change', function() {
          let value = parseInt(input.value);
          
          // If empty or invalid, default to min
          if (isNaN(value)) {
            value = min;
          }
          
          // Clamp to valid range
          value = Math.max(min, Math.min(max, value));
          input.value = value;
          updateButtons();
          
          // Debounced submit for manual input to avoid too many requests
          debouncedSubmit();
        });

        // Also handle input event for immediate feedback during typing
        input.addEventListener('input', function() {
          updateButtons();
        });

        updateButtons();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQuantityInputs);
    } else {
      initQuantityInputs();
    }

    // Reinitialize after liquid-ajax-cart updates the DOM
    document.addEventListener('liquid-ajax-cart:request-end', function() {
      // Reset initialized state for re-rendered elements
      document.querySelectorAll('.quantity-input[data-initialized]').forEach(function(el) {
        delete el.dataset.initialized;
      });
      initQuantityInputs();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
